import { Tooltip, TooltipPosition } from '@tableau/widgets';
import * as React from 'react';
import { AngularDirective } from '../../common/react/components/AngularDirective';
import { AngularContext } from '../../ts/factories/AngularContextFactory';
export interface SiteRolePopoverProps {
  readonly angularContext: AngularContext;
}

export class SiteRolePopover extends React.PureComponent<SiteRolePopoverProps> {
  constructor(props: SiteRolePopoverProps) {
    super(props);
  }
  public render() {
    return (
      <Tooltip getContent = {this.getContent} position = {TooltipPosition.Right} maxWidth = {700}>
        <div className="tb-header-row-icon-centered tb-icon-help"></div>
      </Tooltip>
    );
  }
  private getContent = (): JSX.Element => {
    return (
      <div>
        <AngularDirective angularContext={this.props.angularContext} template={'<tb:site-role-permissions-table></tb:site-role-permissions-table>'}/>
      </div>
    );
  }
}
